// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Orders_SalvarAtributosLaudoInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /so/orders/salvar_atributos_laudo/{order_item_id}/{report_type}
 *
 * Saves attribute values for an entry or exit report.
 * The values array contains entries with attribute_id and value.
 *
 * Fields:
 *   values — Orders_OrderItemAttributeInputRow[], required
 *            (each row: { attribute_id: int, value: string }; persisted via
 *             So_report_attribute_values_model::replaceForReport)
 */
import type { Orders_OrderItemAttributeInputRow } from './Orders_OrderItemAttributeInputRow'
import { registerContract } from './validate'

export interface Orders_SalvarAtributosLaudoInput {
values?: Orders_OrderItemAttributeInputRow[]
}

registerContract('Orders_SalvarAtributosLaudoInput', {
  values: {
    type: 'array',
    required: false,
    items: {
      attribute_id: { type: 'number',  required: true },
      value:        { type: 'string',  required: false },
    },
  },
})
